/* unplugin-vue-components disabled */import { render } from "./SelectEspace.vue?vue&type=template&id=0b98e42d&scoped=true&ts=true"
import script from "./SelectEspace.vue?vue&type=script&lang=ts"
export * from "./SelectEspace.vue?vue&type=script&lang=ts"

import "./SelectEspace.vue?vue&type=style&index=0&id=0b98e42d&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b98e42d"]])

export default __exports__